<button class="btn-transparent" type="button" disabled="disabled" [ngClass]="styles.webcastNavBtn" [hidden]="!(isStarting || broadcast.isStopping)" vbBtnPrimary>
	{{ 'Event_Standby' | translate }}
</button>

<button type="button" [ngClass]="styles.webcastNavBtn" [hidden]="broadcast.isStopping || !broadcast.isActive" [disabled]="webcast.isVodSource" (click)="stopBroadcast()" vbBtnPrimary>
	{{ (webcast.isVodSource ? 'Event_Broadcasting' : 'Event_PauseBroadcast') | translate }}
</button>

<button type="button" [ngClass]="styles.webcastNavBtn" [hidden]="isStarting || broadcast.isActive" (click)="startBroadcast()" [disabled]="!webcastStatus.isInProgress" vbBtnPrimary>
	{{ broadcast.hasBeenActive ? ('Event_ResumeBroadcast' | translate) : ('Event_Broadcast' | translate) }}
</button>
